exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settlement-settings-panel[data-v-5563e0e7] {\n  width: 380px;\n  min-width: 340px;\n  max-width: 420px;\n  height: calc(100vh - 6rem);\n}\n.settlement-settings-modal-enter-active[data-v-5563e0e7],\n.settlement-settings-modal-leave-active[data-v-5563e0e7] {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.settlement-settings-modal-enter-from[data-v-5563e0e7],\n.settlement-settings-modal-leave-to[data-v-5563e0e7] {\n  transform: translateX(100%);\n}\n.settlement-settings-modal-enter-to[data-v-5563e0e7],\n.settlement-settings-modal-leave-from[data-v-5563e0e7] {\n  transform: translateX(0);\n}\n", ""]);

// exports
